import { useTranslation } from "react-i18next";

// Aviso de devolución (spec 008, Incremento 2, RF-33, plan.md §14.3 — T-APP-21). Se monta SIEMPRE dentro de
// IniciativaFormModal, arriba de la Sección 1, y solo se pinta cuando el estado ACTUAL de la iniciativa es
// Devuelta (CA-33/CA-38: al editar y guardar pasa a Guardado y el aviso deja de mostrarse, aunque las
// filas de historial se conservan en la base).
//
// Muestra SOLO el comentario de cada devolución, del más reciente al más antiguo (el SP ya entrega el
// historial ordenado `Fecha DESC`, plan.md §18.6) — SIN autor ni fecha en pantalla, aunque el historial SÍ
// los trae (CA-37). Es una decisión de producto deliberada, NO un olvido: no "arreglar" esto agregando
// autor/fecha.
//
// R-14/H-05/CA-39: `{comentario}` se renderiza como texto — React escapa por defecto. El motivo se guarda
// literal en el servidor sin sanitizar (se verificó que acepta `<script>...`), así que el escape de React
// es la única defensa real acá. Prohibido `dangerouslySetInnerHTML`.
const AvisoDevolucion = ({ historial, visible }) => {
  const [t] = useTranslation("iniciativasIA");

  if (!visible) return null;

  const comentarios = (historial || [])
    .filter((h) => h.CodigoEstadoNuevo === "DEVUELTA" && h.Comentario)
    .map((h) => h.Comentario);

  if (!comentarios.length) return null;

  return (
    <div className="alert alert-danger mb-4" role="alert">
      <h6 className="font-weight-bold mb-2">
        <i className="fa fa-exclamation-triangle mr-2"></i>
        {t("iniciativasIA_aviso_devolucion_title")}
      </h6>
      <ul className="mb-0 pl-3">
        {comentarios.map((comentario, idx) => (
          <li key={idx}>{comentario}</li>
        ))}
      </ul>
    </div>
  );
};

export default AvisoDevolucion;
